module.exports = __webpack_public_path__ + "img/DOGE.f5de18a0.svg";